import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { updateCustomValue } from '../../components/UserFunctions'
//import { getDataTab } from '../../components/UserFunctions'
import PropTypes from 'prop-types';

class TableKPI extends Component {
    constructor(props) {
        super(props)
        this.state = {
            elementIndex: undefined,
            value: "",
            
         
           
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addCustomValue = this.addCustomValue.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        
    }
    openModal(event){
        const index = event.target.value;
        this.setState((prevState) => {
            return{
                ...prevState,
                elementIndex: index
            }
        })
    }
    closeModal() {
        this.setState((prevState) => {
            return {
                ...prevState,
                elementIndex: undefined
            }
        })
    }
    addCustomValue(e) {
        e.preventDefault()
        this.props.data[this.state.elementIndex].custom_value = this.state.value
        const destUrl= (window.location.origin).concat('/update_custom_value')
        const destPayload = {
            name: this.props.name,
            kpi : this.props.data[this.state.elementIndex].name,
            customValue: this.state.value
        }
        console.log(destPayload);
        updateCustomValue(destUrl, destPayload).then((response) => { 
            console.log(response)             
                 })
        

        this.closeModal();
    }
 
    onValueChange(e){
        console.log(e.target.value)
        this.setState({[e.target.name] : e.target.value})
    }

    render() {
        return (
            <div data-test ='kpiManagerTableKPIComponent' className="card card-body mt-2">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card card-body">
                            <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white" }}>
                                <h2>KPI Selector -Feature / {this.props.name}</h2>
                                <div className="col-md-12 text-right" style={{ marginTop: "-2%" }}>
                                    <Link to="/welcomeautomatekpi/landingkpidashboard"  >
                                        <button className="btn btn-light  float-right" style={{ textDecoration: "none", color: "#757AF7", backgorundColor: "#FFFFFF" }}>KPI Dashboard
                                        </button>
                                    </Link>
                                </div>
                            </div>
                            <table className="table table-bordered table-striped text-center">
                                <thead className="table-head">
                                    <tr>
                                        <th style={{ textAlign: "center" }}>List of KPIs</th>
                                        <th style={{ textAlign: "center" }}>Value</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.data.map((element, index) => {
                                        return (
                                            <tr key={index} className="table-row">
                                                <td style={{ textAlign: "center" }}>{element.name}</td>
                                                {element.custom_value==="NULL" ? <td> {element.value}</td>: <td>{element.value}({element.custom_value})</td>}
                                                 
                                                <td>
                                                    <input type="checkbox" value="" id="defaultCheck1"  ></input>
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    <button className="btn" value={index} onClick={(e) => { this.openModal(e) }} style={{ backgroundColor: "#753DFF" }} >Add Custom Value </button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {this.state.elementIndex ? (
                    <Modal isOpen={true}>
                        <ModalHeader
                            toggle={this.closeModal}
                            style={{ backgroundColor: "#753DFF" }}
                        >
                            Add Custom Value
                        </ModalHeader>
                        <ModalBody>
                            <form onSubmit={this.addCustomValue}>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="value"
                                        placeholder="Enter Custom Value"
                                        value={this.state.value}
                                        onChange={(e) => { this.onValueChange(e) }}
                                    />
                                </div>
                                <button type="submit" className="btn">Submit</button>
                            </form>
                        </ModalBody>
                        <ModalFooter>
                            <Button className="btn" style={{ backgroundColor: "#753DFF" }} onClick={this.closeModal}>Close</Button>
                        </ModalFooter>
                    </Modal>
                ) : undefined}
            </div>
        )
    }
}
TableKPI.propTypes={
data:PropTypes.string,
name:PropTypes.string,
}
TableKPI.defaultProps= {
data:[],
name:[],
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

//     })

//     //this.props.dispatch(editScenarioGroupData(submitValue));
//     //this.props.handleEditModalClose();
// };

export default TableKPI;
